import { Checkbox } from 'informed';
import PropTypes from 'prop-types';
import { useState } from 'react';

import './styles/switchStyles.css';

const Switch = ({
  disabled,
  falseLabel,
  field,
  humanName,
  initialValue,
  trueLabel,
}) => {
  const [isChecked, setIsChecked] = useState(initialValue);
  return (
    <fieldset disabled={disabled}>
      <legend className="sr-only">{humanName}</legend>
      <Checkbox
        className="switch-checkbox absolute opacity-0"
        field={field}
        id={field}
        initialValue={initialValue}
        onValueChange={setIsChecked}
      />
      <label
        className={`switch text-gray-4 cursor-pointer font-normal pl-14 relative ${
          isChecked ? 'is-checked' : ''
        }`}
        htmlFor={field}
      >
        {isChecked ? trueLabel : falseLabel}
      </label>
    </fieldset>
  );
};

Switch.defaultProps = {
  disabled: false,
  initialValue: false,
};

Switch.propTypes = {
  disabled: PropTypes.bool,
  falseLabel: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  humanName: PropTypes.string.isRequired,
  initialValue: PropTypes.bool,
  trueLabel: PropTypes.string.isRequired,
};

export default Switch;
